module.exports = __webpack_public_path__ + "img/people-tab3.0fa3d219.png";